import router from '@/routes'

// TODO @TFU: Exchange with native useRouter composable from vue-router package once upgraded to Vue 3.
export function useRouter () {
    return router
}
